import { Box, CardMedia, Typography } from '@mui/material'
import { addDays, format } from 'date-fns'
import { useQuery } from 'react-query'

// local imports
import default_company_photo from 'assets/images/default_company_photo.png'
import { getCompanyDetails } from 'services/api/company-details'
import AdxDrawerComponent from 'components/reusable/drawer/AdxDrawerComponent'
import SnackbarRecruitment from 'module/recruitment/reusable/SnackbarRecruitment'
import useOpenClose from 'services/hooks/useOpenClose'
import AdxButton from 'components/custom/AdxButton'

const PublishJobAdsDrawer = ({
  data,
  drawerState,
  handleDrawer,
  handleSubmit,
  handleTypeOfForm,
  isValid,
  errors,
}) => {
  const { data: companyDetails } = useQuery('companyDetails', getCompanyDetails)
  const { formData, position_level, job_specialization, qualification, grade, courses, skills } =
    data
  //error modal
  const errorSnackbar = useOpenClose(false)

  let experienceString
  if (formData.year_of_experience === 1) {
    experienceString = 'Fresh graduates are welcome to apply'
  } else if (formData.year_of_experience === 2) {
    experienceString = '1-3 years'
  } else if (formData.year_of_experience === 3) {
    experienceString = '3-5 years'
  } else if (formData.year_of_experience === 4) {
    experienceString = 'More than 5 years'
  } else {
    experienceString = '-'
  }

  // skill text tag component
  const Skills = ({ word }) => {
    return (
      <Box
        display="flex"
        alignItems="center"
        bgcolor="gray-background.main"
        sx={{
          borderRadius: '6px',
        }}
      >
        <Typography variant="body1" color="dark-text.main" padding={1} align="center">
          {word}
        </Typography>
      </Box>
    )
  }
  return (
    <AdxDrawerComponent
      state={drawerState}
      anchor="right"
      onClose={handleDrawer}
      sx={{ padding: 0, zIndex: 1 }}
      sxIcon={{ marginRight: 6.25, marginY: 2 }}
      sxHeader={{
        borderBottom: '1px solid',
        borderColor: 'gray-line.main',
      }}
      headerprops={
        <Box px={6.25} display="flex" columnGap={2}>
          {/* Job header */}
          <Box display="flex" alignItems="center" columnGap={2} py={3}>
            <CardMedia
              component="img"
              sx={{
                height: 52,
                width: 52,
                objectFit: 'cover',
                borderRadius: '50%',
                // border: '3px solid',
                // borderColor: 'alternate.main',
              }}
              alt="Company Image"
              src={companyDetails?.data?.organization_logo || default_company_photo}
              loading="lazy"
            />
            <Box>
              <Typography variant="subtitle1">
                {formData.position_title ? formData.position_title : 'No position title'}
              </Typography>
              {companyDetails?.data?.organization_name ? (
                <Typography variant="subtitle1" color="light-gray-text.main">
                  {companyDetails?.data?.organization_name}
                </Typography>
              ) : null}

              {formData?.job_advertisement_duration ? (
                <Typography variant="subtitle1" color="light-gray-text.main">
                  Expires on{' '}
                  {format(addDays(new Date(), formData.job_advertisement_duration), 'dd MMM yyyy')}
                </Typography>
              ) : null}
            </Box>
          </Box>
        </Box>
      }
    >
      <Box>
        <Box
          padding={6.25}
          display="flex"
          flexDirection="column"
          gap={4}
          mb={4}
          sx={{ zIndex: '1300 !important' }}
        >
          {/* job detail */}
          <Box
            bgcolor="white.main"
            sx={{
              width: '100%',
            }}
          >
            <Typography
              mb={2}
              textAlign="left"
              variant="h4"
              color="dark-text.main"
              fontWeight="bold"
            >
              Job Details
            </Typography>
            <Box display="flex" columnGap={4} mt={1}>
              <Typography
                textAlign="left "
                variant="body1"
                color="light-gray-text.main"
                align="center"
                width={130}
              >
                Position level
              </Typography>
              <Typography
                textAlign="left "
                variant="body1"
                color="dark-text.main"
                align="center"
                textTransform="capitalize"
              >
                {position_level?.length ? position_level[0].level_name : '-'}
              </Typography>
            </Box>
            <Box display="flex" columnGap={4} mt={1}>
              <Typography
                textAlign="left "
                variant="body1"
                color="light-gray-text.main"
                align="center"
                width={130}
              >
                Specialization
              </Typography>
              <Typography
                textAlign="left "
                variant="body1"
                color="dark-text.main"
                align="center"
                textTransform="capitalize"
              >
                {job_specialization?.length ? job_specialization[0].job_background_name : '-'}
              </Typography>
            </Box>
            <Box display="flex" columnGap={4} mt={1}>
              <Typography
                textAlign="left "
                variant="body1"
                color="light-gray-text.main"
                align="center"
                width={130}
              >
                Employment type
              </Typography>
              <Typography
                textAlign="left "
                variant="body1"
                color="dark-text.main"
                align="center"
                textTransform="capitalize"
              >
                {formData?.position_type !== '' ? formData.position_type : '-'}
              </Typography>
            </Box>
            <Box display="flex" columnGap={4} mt={1}>
              <Typography
                textAlign="left "
                variant="body1"
                color="light-gray-text.main"
                align="center"
                width={130}
              >
                Salary
              </Typography>
              <Typography
                textAlign="left "
                variant="body1"
                color="dark-text.main"
                align="center"
                textTransform="capitalize"
              >
                {formData.min_salary && formData.max_salary
                  ? `RM ${formData.min_salary} - RM ${formData.max_salary}`
                  : '-'}
              </Typography>
            </Box>
            <Box display="flex" columnGap={4} mt={1}>
              <Typography
                textAlign="left "
                variant="body1"
                color="light-gray-text.main"
                align="center"
                width={130}
              >
                Work Location
              </Typography>
              <Typography
                textAlign="left "
                variant="body1"
                color="dark-text.main"
                align="center"
                textTransform="capitalize"
              >
                {formData.city && formData.state ? `${formData.city}, ${formData.state}` : '-'}
              </Typography>
            </Box>
          </Box>
          {/* job description */}
          <Box
            bgcolor="white.main"
            sx={{
              width: '100%',
            }}
          >
            <Typography
              mb={2}
              textAlign="left"
              variant="h4"
              color="dark-text.main"
              fontWeight="bold"
            >
              Job Description
            </Typography>
            <Typography
              whiteSpace="pre-wrap"
              textAlign="left "
              variant="body1"
              color="dark-text.main"
              align="center"
            >
              {formData.job_description !== '' ? formData.job_description : '-'}
            </Typography>
          </Box>
          {/* job requirment */}
          <Box
            bgcolor="white.main"
            mb={4}
            sx={{
              width: '100%',
            }}
          >
            <Typography
              mb={2}
              textAlign="left"
              variant="h4"
              color="dark-text.main"
              fontWeight="bold"
            >
              Job Requirements
            </Typography>
            <Box display="flex" columnGap={4} mt={1}>
              <Typography
                textAlign="left "
                variant="body1"
                color="light-gray-text.main"
                align="center"
                width={130}
              >
                Qualification
              </Typography>
              <Typography
                textAlign="left "
                variant="body1"
                color="dark-text.main"
                align="center"
                textTransform="capitalize"
              >
                {qualification?.length ? qualification[0].qualification_name : '-'}
              </Typography>
            </Box>
            <Box display="flex" columnGap={4} mt={1}>
              <Typography
                textAlign="left "
                variant="body1"
                color="light-gray-text.main"
                align="center"
                width={130}
              >
                Work Experience
              </Typography>
              <Typography
                textAlign="left "
                variant="body1"
                color="dark-text.main"
                align="center"
                textTransform="capitalize"
              >
                {experienceString}
              </Typography>
            </Box>
            <Box mt={1}>
              <Typography
                textAlign="left "
                variant="body1"
                color="light-gray-text.main"
                align="center"
                width={130}
              >
                Skills
              </Typography>
              {skills?.length ? (
                <Box display="flex" columnGap={2} rowGap={2} flexWrap="wrap" alignItems="center">
                  {skills?.map((item) => (
                    <Skills key={item} word={item.name} />
                  ))}
                </Box>
              ) : (
                <Typography
                  whiteSpace="pre-wrap"
                  textAlign="left "
                  variant="body1"
                  color="dark-text.main"
                  align="center"
                >
                  -
                </Typography>
              )}
            </Box>
            <Box mt={1}>
              <Typography
                textAlign="left "
                variant="body1"
                color="light-gray-text.main"
                align="center"
                width={170}
              >
                Other Requirements
              </Typography>
              <Typography
                whiteSpace="pre-wrap"
                textAlign="left "
                variant="body1"
                color="dark-text.main"
                align="center"
              >
                {formData.job_requirement !== '' ? formData.job_requirement : '-'}
              </Typography>
            </Box>
          </Box>
        </Box>
        <Box
          mt={5}
          width={{ xs: '100vw', lg: 710 }}
          padding={2}
          bgcolor="white.main"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          sx={{
            position: 'fixed',
            bottom: '0px',
            right: '0px',
            borderTop: '1px solid',
            borderTopColor: 'gray-line.main',
            zIndex: 4090,
          }}
        >
          <Box>
            <Typography textAlign="left " variant="subtitle1" color="dark-text.main" align="center">
              Ready to publish?
            </Typography>
            {formData.job_advertisement_duration ? (
              <Typography
                textAlign="left "
                variant="body2"
                color="light-gray-text.main"
                align="center"
              >
                This job advertisement will be visible to jobseekers until{' '}
                {format(addDays(new Date(), formData.job_advertisement_duration), 'dd MMM yyyy')}
              </Typography>
            ) : null}
          </Box>
          <Box display="flex" columnGap={2}>
            <AdxButton variant={'outlined'} size="standard" onClick={handleDrawer('right', false)}>
              Cancel
            </AdxButton>

            <AdxButton
              variant={'contained'}
              size="standard"
              sx={{ width: 150 }}
              onClick={() => {
                if (!isValid) {
                  errorSnackbar.handleOpen()
                }
                handleSubmit()
                handleTypeOfForm('publish')
              }}
            >
              Activate
            </AdxButton>
          </Box>
        </Box>

        {errorSnackbar.isOpen ? (
          <SnackbarRecruitment
            autoHideDuration={4000}
            status="error"
            TransitionComponent="slide"
            message="You have an incomplete field"
            open={errorSnackbar.isOpen}
            handleClose={errorSnackbar.handleClose}
          />
        ) : null}
      </Box>
    </AdxDrawerComponent>
  )
}
export default PublishJobAdsDrawer
